export default "__VITE_ASSET__CnGZa5Aw__"